<template>

      <div class="auth-box-w">
        <div class="logo-w">
          <a href="index.html"><img alt="" src="@/img/brand-drachei-big.svg" class="img-fluid"></a>
        </div>
        <h4 class="auth-header">
          Login Credenciado
        </h4>
        <form @submit.prevent="auth()">
          <div v-if="msgErro" class="alert alert-danger">
              {{msgErro}}
          </div>
          <div class="form-group">
            <label for="">Usuário</label>
            <input required v-model="credentials.username" class="form-control" placeholder="Digite seu usuário" type="text">
            <div class="pre-icon os-icon os-icon-user-male-circle"></div>
          </div>
          <div class="form-group">
            <label for="">Senha</label>
            <input required v-model="credentials.password" class="form-control" placeholder="Digite sua senha" type="password">
            <div class="pre-icon os-icon os-icon-fingerprint"></div>
          </div>
          <div class="buttons-w mb-2">
            <button class="btn btn-primary">
              Entrar
            </button>
            
            <div class="form-check-inline">
              <label class="form-check-label"><input class="form-check-input" type="checkbox">Manter conectado</label>
            </div>
          </div>
          <div class="row">
            <div class="col-6 text-center">
              <a class="btn btn-light" @click.stop.prevent="recuperarSenha()"><small>Esqueci minha senha</small></a>
            </div>
          </div>
        </form>
       
      </div>

</template>
<script>
import eventBus from '@/event-bus'

export default {
  data () {
    return {
      msgErro: null,
      credentials: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    isValid () {
      return true
    },
    auth () {
      if (this.isValid()) {
        var payload = {
          username: this.credentials.username,
          password: this.credentials.password
        }
        this.$store.dispatch('login', payload)
          .then((user) => {
            this.msgErro = null
            this.$router.push({name: 'HomeAdmin'})
          })
          .catch(error => {
            console.log(error)
            this.msgErro = error.message
          })
      }
    },
    recuperarSenha () {
      eventBus.$emit('openModal', 'esqueciSenhaCliente')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Login.vue